var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "addAdress" }, [
    _c("div", { staticClass: "Requirement" }, [
      _c("div", { staticClass: "letRe fl" }, [_vm._v("联系人")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contactName,
            expression: "contactName"
          }
        ],
        staticClass: "rigRe fr",
        attrs: { placeholder: "请填写姓名" },
        domProps: { value: _vm.contactName },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.contactName = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "Requirement" }, [
      _c("div", { staticClass: "letRe fl" }, [_vm._v("手机号")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contactPhone,
            expression: "contactPhone"
          }
        ],
        staticClass: "rigRe fr",
        attrs: { placeholder: "请输入手机号" },
        domProps: { value: _vm.contactPhone },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.contactPhone = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "Requirement" }, [
      _c("div", { staticClass: "letRe fl" }, [_vm._v("详细地址")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.addressDesc,
            expression: "addressDesc"
          }
        ],
        staticClass: "rigRe fr",
        attrs: { placeholder: "请输入详细地址" },
        domProps: { value: _vm.addressDesc },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.addressDesc = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "Requirement" }, [
      _c("div", { staticClass: "letRe fl" }, [_vm._v("默认地址")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "swich_moren" },
        [
          _c("div"),
          _vm._v(" "),
          _c("mt-switch", {
            model: {
              value: _vm.isDefault,
              callback: function($$v) {
                _vm.isDefault = $$v
              },
              expression: "isDefault"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "save_add", on: { click: _vm.handlePreserve } }, [
      _vm._v("\n    保存地址\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-754b6371", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-754b6371","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/addAdress/index.vue
// module id = null
// module chunks = 